import { motion } from "motion/react";
import Button from "../Button";
import heroImage from "../../assets/images/hero_l.png";

export default function Hero() {
  return (
    <section className="relative overflow-hidden">
      <div className="relative min-h-screen sm:min-h-[95svh] flex items-center justify-center overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-r from-primary-100 via-primary-100 via-40% to-white" />

        <div className="absolute inset-0">
          <motion.div
            className="absolute -top-32 -right-40 w-[600px] h-[600px] bg-primary-300/24 rounded-full mix-blend-multiply filter blur-[100px]"
            animate={{
              scale: [1, 1.2, 1],
              x: [0, 30, 0],
              y: [0, 20, 0],
            }}
            transition={{
              duration: 8,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />

          <motion.div
            className="absolute -bottom-10 -right-20 w-[500px] h-[500px] bg-primary-200/12 rounded-full mix-blend-multiply filter blur-[130px]"
            animate={{
              scale: [1, 1.3, 1],
              x: [0, -20, 0],
              y: [0, -30, 0],
            }}
            transition={{
              duration: 10,
              repeat: Infinity,
              ease: "easeInOut",
            }}
          />

          <motion.div
            initial={{ opacity: 0, x: -100, scale: 0.9 }}
            animate={{ opacity: 1, x: 0, scale: 1 }}
            transition={{
              duration: 1,
              delay: 0.3,
              type: "spring",
              damping: 20,
            }}
            className="absolute hidden lg:block left-[42%] -translate-x-1/2"
            style={{
              width: "1000px",
              height: "667px",
              bottom: "-100px",
              marginLeft: "-500px",
            }}
          >
            <img
              src={heroImage}
              alt="Formly platform preview"
              className="w-full h-full object-cover rounded-2xl"
            />
          </motion.div>
        </div>

        <div className="relative z-10 section-container text-center space-x-3 md:space-y-5">
          <motion.div
            className="inline-block"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.6 }}
          >
            <span className="gap-2 px-4 py-2 mb-2 md:mb-3 bg-primary-500/5 backdrop-blur-md text-slate-600 rounded-full text-lg font-semibold border border-primary-300/30 inline-flex items-center">
              <span className="w-2 h-2 bg-primary-500 rounded-full text-sm md:text-base"></span>
              Marketplace pour formateurs indépendants
            </span>
          </motion.div>

          <motion.div
            className="relative inline-block"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.1, ease: "easeOut" }}
          >
            {/* Icône écho gauche - 3 traits */}
            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.8, type: "spring" }}
              className="absolute left-15 top-0 hidden xl:block"
            >
              <motion.div
                animate={{
                  scale: [1, 1.1, 1],
                  opacity: [0.7, 1, 0.7],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
                className="space-y-2"
              >
                <div className="w-8 h-1 bg-yellow-500 rounded-full transform -rotate-140" />
                <div className="w-10 h-1 bg-yellow-500 rounded-full transform -rotate-160" />
                <div className="w-6 h-1 bg-yellow-500 rounded-full transform -rotate-180" />
              </motion.div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, scale: 0 }}
              animate={{ opacity: 1, scale: 1 }}
              transition={{ duration: 0.6, delay: 0.9, type: "spring" }}
              className="absolute right-15 top-0 hidden xl:block"
            >
              <motion.div
                animate={{
                  scale: [1, 1.1, 1],
                  opacity: [0.7, 1, 0.7],
                }}
                transition={{
                  duration: 2,
                  repeat: Infinity,
                  ease: "easeInOut",
                  delay: 0.5,
                }}
                className="space-y-2"
              >
                <div className="w-8 h-1 bg-yellow-500 rounded-full transform rotate-140" />
                <div className="w-10 h-1 bg-yellow-500 rounded-full transform rotate-160" />
                <div className="w-6 h-1 bg-yellow-500 rounded-full transform rotate-180" />
              </motion.div>
            </motion.div>

            <h1 className="text-4xl md:text-6xl lg:text-7xl font-bold text-gray-900">
              <motion.span
                animate={{
                  scale: [1, 1.05, 1],
                  textShadow: [
                    "0px 0px 0px rgba(249, 115, 22, 0)",
                    "0px 0px 20px rgba(249, 115, 22, 0.3)",
                    "0px 0px 0px rgba(249, 115, 22, 0)",
                  ],
                }}
                transition={{
                  duration: 3,
                  repeat: Infinity,
                  ease: "easeInOut",
                }}
              >
                Augmentez gratuitement vos revenus et
              </motion.span>{" "}
              <br />
              <span className="text-primary-500">(re)devenez visible</span>
            </h1>
          </motion.div>

          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
          >
            <p className="text-xl md:text-2xl text-gray-700 section-container font-medium mt-10 mb-2">
              Formly : La plateforme qui vous envoie des apprenants engagés
            </p>

            <div className="text-lx md:text-xl text-gray-600 section-container mb-10">
              <p className="mb-2">
                Nous résolvons le défi du désengagement et de la visibilité pour
                que vous
              </p>
              <p>puissiez atteindre vos objectifs en ligne.</p>
            </div>
          </motion.div>

          <motion.div
            className="flex flex-col items-center gap-6 pt-4"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8, delay: 0.5, ease: "easeOut" }}
          >
            <Button
              variant="primary"
              size="lg"
              showArrow
              onClick={() =>
                window.open("https://calendly.com/contact-formly-app", "_blank")
              }
            >
              Expliquez-moi le fonctionnement en 5 minutes
            </Button>

            <p className="text-sm md:text-base text-gray-600">
              Sans engagement • Visioconférence gratuite{" "}
              <strong>• Réponse en 2h maximum</strong>
            </p>
          </motion.div>
        </div>

        {/* Wave at bottom - vague ondulante vers le haut */}
        <div className="absolute bottom-0 left-0 w-full overflow-hidden leading-none">
          <svg
            className="relative block w-full h-20 md:h-28"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 1200 120"
            preserveAspectRatio="none"
          >
            <path
              d="M 0,120 
     L 40,99.8 
     C 90,82.2 192,49.5 294,24.5 
     C 396,-0.5 498,-0.5 600,10.5 
     C 702,21.5 804,49.5 906,65.5 
     C 1008,81.5 1110,81.5 1161,81.5 
     L 1200,81.5 
     L 1200,120 
     L 1161,120 
     C 1110,120 1008,120 906,120 
     C 804,120 702,120 600,120 
     C 498,120 396,120 294,120 
     C 192,120 90,120 40,120 
     L 0,120 Z"
              className="fill-white"
            ></path>
          </svg>
        </div>
      </div>
    </section>
  );
}
